import common from './common.json';
import global from './global.json';
import navigation from './navigation.json';
import notification from './notification.json';
import type from './type.json';
import validation from './validation.json';
import rentalObjects from './rentalObjects.json';
import reporting from './reporting.json';
import account from './account.json';
import agreements from './agreements.json';
import app from './app.json';
import tenants from './tenants.json';
import portfolio from './portfolio.json';
import dashboard from './dashboard.json';
import widget from './widget.json';
import users from './users.json';
import companies from './companies.json';
import products from './products.json';
import eos from './eos.json';
import economy from './economy.json';

export const no = {
  common,
  global,
  navigation,
  notification,
  type,
  validation,
  rentalObjects,
  reporting,
  account,
  agreements,
  app,
  tenants,
  portfolio,
  dashboard,
  widget,
  users,
  companies,
  products,
  eos,
  economy,
};
